import React from "react";
import HolidayRuleFormModal from "./HolidayRuleFormModal";

const CreateHolidayRule = (props) => {
  return <HolidayRuleFormModal { ...props } />;
};

export default CreateHolidayRule;
